export default __webpack_public_path__ + "static/media/declaracionjuradamemoria2023.82a84b94-2.1772bf4c.png";